import { render, staticRenderFns } from "./AdicionarActivos.vue?vue&type=template&id=288d3d7b"
import script from "./AdicionarActivos.vue?vue&type=script&lang=js"
export * from "./AdicionarActivos.vue?vue&type=script&lang=js"
import style0 from "./AdicionarActivos.vue?vue&type=style&index=0&id=288d3d7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports